
import React from 'react';
import Layout from '@/components/layout/Layout';
import CalendarDashboard from '@/components/calendar/CalendarDashboard';

const CalendarScheduling: React.FC = () => {
  return (
    <Layout>
      <div className="container max-w-7xl py-8">
        <div className="flex flex-col gap-2 mb-6">
          <h1 className="text-3xl font-bold tracking-tight">Calendar & Scheduling</h1>
          <p className="text-muted-foreground">
            Manage your music career schedule with AI-powered assistance
          </p>
        </div>
        
        <CalendarDashboard />
      </div>
    </Layout>
  );
};

export default CalendarScheduling;
